import React from "react"

import Filter from "./filter"
import Item from "./item"
import Footer from "./footer"
import * as styles from "./index.module.css"
import { testIds } from "../../common/constants"
import { usePageContext } from "../../hooks/use-page-context"

const ContentList = ({
  children,
  data,
  filter,
  categories,
  allCategoryTo,
  getCategoryTo,
  render,
}) => {
  const { activeCategory } = usePageContext()

  const filteredData = activeCategory
    ? data.filter(post =>
        post.categories?.some(category => category.slug === activeCategory.slug)
      )
    : [...data]

  return (
    <div className={styles.wrapper}>
      <div className="container mt-6">
        {filter && (
          <Filter
            allCategoryTo={allCategoryTo}
            getCategoryTo={getCategoryTo}
            categories={categories}
            activeCategory={activeCategory}
          />
        )}
        <div className="mt-6 mb-6">
          <div className={styles.list}>
            {filteredData.map(item => (
              <div
                key={item.id}
                data-test-id={testIds.components.contentList.item.container}
                data-categories={item?.categories
                  ?.map(category => category.title)
                  .join(" ")}
              >
                {render(item)}
              </div>
            ))}
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Object.assign(ContentList, { Item, Footer })
